import { UploadType as FileType } from "../types";

export const getDownloadUrl = (downloadType: FileType) => (root: string, orgId: string, accountId: string) =>
  `${root}/organizations/${orgId}/${downloadType}.csv?activeUser=${accountId}`;

export const getDownloadAccountsUrl = getDownloadUrl("accounts");
export const getDownloadMembersUrl = getDownloadUrl("members");
export const getDownloadGroupsUrl = getDownloadUrl("groups");
